<template>
  <div class="general-view dashboard">
    <div class="fixed-bar">
      <DashboardHeader/>
      <DashboardSubHeader />
  <DashboardFooter />

    </div>

    <PageLoading v-if="requestProcessing"  />

    <div v-else>
      <section v-if="!errorOccurred" class="content-wrap">
        <ul>
          <li :data-company="fleet.name" v-for="(fleet, index) in fleetList" :key="fleet.name">
            <Fleet :fleet="fleet" :isFirstIteration="index === 0" />
          </li>

        </ul>


      </section>
      <template>
        <div class="general-view transfer">
          <v-snackbar
              v-model="snackbar.show"
              :timeout="snackbar.timeout"
              :color="snackbar.color"
              top
              right
            >
              {{ snackbar.message }}
              <!-- Close Button for Snackbar -->
              <template v-slot:action="{ attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  @click="closeSnackbar"
                  class="white--text"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </template>
      </div>
  <!--
    <modal :modalName="confirmModal.name" width="460px">
      <ModalConfirm :message="confirmModal.message" :error="confirmModal.error" :warn="true" @modalConfirmed="closeModal()" />
    </modal>
    -->
    </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import NavLayout from '@/layouts/NavLayout'

import DashboardHeader from '../components/DashboardHeader'
import DashboardSubHeader from '../components/DashboardSubHeader'
import Fleet from '../components/Fleet'
import PageLoading from './PageLoading'
import Modal from '../components/modals/Modal'
import ModalConfirm from '../components/modals/ModalConfirm'
import axios from 'axios';
import bus from '../event/bus';
import DashboardFooter from '../components/DashboardFooter'
import { FETCH_FLEET_POLLING } from "../utils/others.js"

export default {
  components: {
    DashboardHeader,
    DashboardSubHeader,
    Fleet,
    PageLoading,
    Modal,
    ModalConfirm,
    DashboardFooter 
},
  data() {
    return {
      fetchingFleetsTimeoutId: null,
      requestProcessing: false,
      errorOccurred: false,
      cancelTokenSource: null,
      previousCancelToken: null,
    /*confirmModal: {
        name: 'errorModal',
        message: '',
        error: false
      },*/
      snackbar: {
        show: false,
        message: '',
        color: 'green', 
      }
    }
  },
  
  computed: {
    ...mapState('appStore', ['modalComponent']),
    ...mapState('fleetStore', ['fleetList', 'fleetQuery']),
    ...mapGetters('userStore', ['canFilter']),
  },
  created() {
    this.$emit('update:layoutComponent', NavLayout)

    bus.$on('submitFilter', this.handleSubmitFilter);
    bus.$on('refreshDashboardEvt', this.handleRefreshDashboardEvt);
  },

  mounted() {
    this.fetchFleetsPolling(true)
    const user_id = parseInt(this.$store.state.userStore.user_name.substring(1));
    //const dtrum = window.dtrum;
    //dtrum.enterAction('Connexion Event', { user_name: user_id });

    const allRoles = this.$store.state.userStore.allRoles;

    if (allRoles && allRoles.length > 1 && !sessionStorage.getItem('roleAlertDismissed')) {
      this.openSnackbar('Your account has more than one role. The least-privileged one will be used.', 'warning', 5000);
      sessionStorage.setItem('roleAlertDismissed', 'true');
    }
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.fetchingFleetsTimeoutId)
    next()
  },
  beforeDestroy() {
    bus.$off('submitFilter', this.handleSubmitFilter);
    bus.$off('refreshDashboardEvt', this.handleRefreshDashboardEvt);
  },

  methods: {
    ...mapActions('fleetStore', ['setFetchedFleet', 'removeAll']),
    ...mapActions('appStore', ['closeModal', 'openModal']),

    cancelRequest() {
      console.log('Request canceled by user');
      this.cancelTokenSource.cancel('Request canceled by user');
    },

    fetchAllFleets(requestProcessing) {
      if (this.previousCancelToken) {
        // Cancel the previous request
        this.previousCancelToken.cancel('New request is being made');
      }
      // Create a new cancel token for the current request
      const cancelToken = axios.CancelToken.source();
      this.previousCancelToken = cancelToken;

      this.requestProcessing = requestProcessing;

      // Make the Axios request with the cancel token
      return this.$requester
        .get(`/helicopters${this.fleetQuery}`, {
          cancelToken: cancelToken.token
        })
        .then(response => {
          // Check if response.data is a string and parse it
          const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

          let updateAvailableTypes = false
          if (!this.fleetQuery) {
            updateAvailableTypes = true
          }

          this.setFetchedFleet({
            fleets: responseData.fleets,
            updateAvailableTypes: updateAvailableTypes
          });
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log('Request canceled', error.message);
          }
          /* else if (error.response) {
            if (error.response.status === 503 || error.response.status === 401) {
              this.showModalWithError('Server Error', 'Data Flow Manager is currently unavailable. Sorry for the inconvenience. Please try again later');
            } 
          */
        })
        .finally(() => {this.requestProcessing = false});
    },

    async fetchFleetsPolling(requestProcessing) {
      // A check to ensure if the component is destroyed to stop fetching
      if (this._isDestroyed || this._isBeingDestroyed) {
        return;
      }
      try {
        // Only fetch if there no active modal
        if (this.modalComponent === '') {
          await this.fetchAllFleets(requestProcessing);
        }
      } catch (error) {
        console.error('Error fetching fleets:', error);
      }

      this.fetchingFleetsTimeoutId = setTimeout(() => {
        this.fetchFleetsPolling(false);
      }, FETCH_FLEET_POLLING);
    },

    showModalWithError(title, message) {
      this.confirmModal.error = true;
      this.confirmModal.message = message;
      this.confirmModal.name = title.toLowerCase().replace(/\s+/g, '') + 'Modal'; // Generate modal name
      this.openModal(this.confirmModal.name);
    },

    showError(message) {
      this.errorOccurred = true;
      this.errorMessage = message;
    },

    modalConfirmOk() {
      this.$router.go();
    },

    modalResponseError(errorMsg) {
      this.confirmModal.error = true;
      this.confirmModal.message = errorMsg;
      this.closeModal();
      this.openModal(this.confirmModal.name);
    },

    closeSnackbar() {
      this.snackbar.show = false;
    },
    openSnackbar(msg, level="info", timeout=3000) {
      if (level === "info") {
        this.snackbar.color = "green"
      }
      if (level === "error") {
        this.snackbar.color = "red"
      }
      if (level === "warning") {
        this.snackbar.color = "orange"
      }
      this.snackbar.timeout = timeout;
      this.snackbar.message = msg;
      this.snackbar.show = true;
    },

    handleRefreshDashboardEvt(msg) {

      this.removeAll();
      try {
        this.fetchAllFleets(true);
      }
      catch (error) {
        console.log("Error:", error);
      }
      this.openSnackbar(msg);
    },

    handleSubmitFilter(payload) {
      if (payload.state) {
        // Cancel the previous request
        if (this.previousCancelToken) {
          console.log('New request is being made')
          this.previousCancelToken.cancel('New request is being made');
        }
      }
    },
  }
};
</script>

<style>
.error-message {
  padding: 20px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  border-radius: 4px;
  margin-bottom: 20px;
}

.error-message p {
  margin: 0;
}

</style>